import chatIdentifiers from '@/helpers/chatIdentifiers'
import BaseModel from '@/services/api/BaseModel'
import Store from '@/store'

export default class ChatReport extends BaseModel {
  constructor() {
    super()
    this._service = 'chat/api/v1'
    this._model = ''
  }

  createReport(status) {
    return this.post(
      `${this.resourceUrl}client-chat-status`,
      {
        configId: chatIdentifiers.configSid,
        contactSid: Store.state.Widget.externalIdentity,
        status,
      },
      {
        headers: {
          'X-Domain-Url': window.location.hostname,
        },
      },
    )
  }
}
